class MiniMeSpeechBubble {
	constructor(svgDoc, bubble) {
		this.namespace = "http://www.w3.org/2000/svg";
		this.bubble = document.createElementNS(this.namespace, "image");
		this.bubble.setAttribute("x", bubble.x);
		this.bubble.setAttribute("y", bubble.y);
		this.bubble.setAttribute("width", bubble.width);
		this.bubble.setAttribute("height", bubble.height);
		this.bubble.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', bubble.src);
		this.bubble.setAttribute("style", "opacity:0");
		svgDoc.appendChild(this.bubble);
		this.fadeInSpeechbubble();

		window.setTimeout(function() {
			this.fadeOutSpeechbubble();
		}.bind(this), 3000);
	}

	fadeInSpeechbubble() {
		gsap.to(this.bubble, {
			opacity: 1,
			duration: 0.5
		});
	}

	fadeOutSpeechbubble() {
		gsap.to(this.bubble, {
			opacity: 0,
			duration: 0.5,
			onComplete: () => {
				this.bubble.style.display = "none";
			}
		});
	}
}
